import { getTimezoneOffsetInMilliseconds as Y } from "../_lib/getTimezoneOffsetInMilliseconds/index.js";
import { tzParseTimezone as T } from "../_lib/tzParseTimezone/index.js";
import { tzPattern as m } from "../_lib/tzPattern/index.js";
const c = 36e5, N = 6e4, M = 2, l = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: m
};
function F(t, e = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  const n = e.additionalDigits == null ? M : Number(e.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (Object.prototype.toString.call(t) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const r = x(t), { year: i, restDateString: a } = H(r.date, n), s = O(a, i);
  if (s === null || isNaN(s.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (s) {
    const o = s.getTime();
    let f = 0, u;
    if (r.time && (f = b(r.time), f === null || isNaN(f)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || e.timeZone) {
      if (u = T(r.timeZone || e.timeZone, new Date(o + f)), isNaN(u))
        return /* @__PURE__ */ new Date(NaN);
    } else
      u = Y(new Date(o + f)), u = Y(new Date(o + f + u));
    return new Date(o + f + u);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function x(t) {
  const e = {};
  let n = l.dateTimePattern.exec(t), r;
  if (n ? (e.date = n[1], r = n[3]) : (n = l.datePattern.exec(t), n ? (e.date = n[1], r = n[2]) : (e.date = null, r = t)), r) {
    const i = l.timeZone.exec(r);
    i ? (e.time = r.replace(i[1], ""), e.timeZone = i[1].trim()) : e.time = r;
  }
  return e;
}
function H(t, e) {
  if (t) {
    const n = l.YYY[e], r = l.YYYYY[e];
    let i = l.YYYY.exec(t) || r.exec(t);
    if (i) {
      const a = i[1];
      return {
        year: parseInt(a, 10),
        restDateString: t.slice(a.length)
      };
    }
    if (i = l.YY.exec(t) || n.exec(t), i) {
      const a = i[1];
      return {
        year: parseInt(a, 10) * 100,
        restDateString: t.slice(a.length)
      };
    }
  }
  return {
    year: null
  };
}
function O(t, e) {
  if (e === null)
    return null;
  let n, r, i;
  if (!t || !t.length)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(e), n;
  let a = l.MM.exec(t);
  if (a)
    return n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1, w(e, r) ? (n.setUTCFullYear(e, r), n) : /* @__PURE__ */ new Date(NaN);
  if (a = l.DDD.exec(t), a) {
    n = /* @__PURE__ */ new Date(0);
    const s = parseInt(a[1], 10);
    return U(e, s) ? (n.setUTCFullYear(e, 0, s), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = l.MMDD.exec(t), a) {
    n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1;
    const s = parseInt(a[2], 10);
    return w(e, r, s) ? (n.setUTCFullYear(e, r, s), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = l.Www.exec(t), a)
    return i = parseInt(a[1], 10) - 1, d(i) ? p(e, i) : /* @__PURE__ */ new Date(NaN);
  if (a = l.WwwD.exec(t), a) {
    i = parseInt(a[1], 10) - 1;
    const s = parseInt(a[2], 10) - 1;
    return d(i, s) ? p(e, i, s) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function b(t) {
  let e, n, r = l.HH.exec(t);
  if (r)
    return e = parseFloat(r[1].replace(",", ".")), D(e) ? e % 24 * c : NaN;
  if (r = l.HHMM.exec(t), r)
    return e = parseInt(r[1], 10), n = parseFloat(r[2].replace(",", ".")), D(e, n) ? e % 24 * c + n * N : NaN;
  if (r = l.HHMMSS.exec(t), r) {
    e = parseInt(r[1], 10), n = parseInt(r[2], 10);
    const i = parseFloat(r[3].replace(",", "."));
    return D(e, n, i) ? e % 24 * c + n * N + i * 1e3 : NaN;
  }
  return null;
}
function p(t, e, n) {
  e = e || 0, n = n || 0;
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  const i = r.getUTCDay() || 7, a = e * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + a), r;
}
const _ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], $ = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function I(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function w(t, e, n) {
  if (e < 0 || e > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    const r = I(t);
    if (r && n > $[e] || !r && n > _[e])
      return !1;
  }
  return !0;
}
function U(t, e) {
  if (e < 1)
    return !1;
  const n = I(t);
  return !(n && e > 366 || !n && e > 365);
}
function d(t, e) {
  return !(t < 0 || t > 52 || e != null && (e < 0 || e > 6));
}
function D(t, e, n) {
  return !(t < 0 || t >= 25 || e != null && (e < 0 || e >= 60) || n != null && (n < 0 || n >= 60));
}
export {
  F as toDate
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns-tz@3.2.0_date-fns@3.6.0/~/date-fns-tz/dist/esm/toDate/index.js
// module id = 877
// module chunks = 67